<template>
  <header v-if="stock" class="external-view-head">
    <WatchlistToggle :stock="stock" />
    <Icon name="expand" @click.native="openStock" />
    <Icon name="cross" @click.native="close" />
  </header>
</template>
<script>
import WatchlistToggle from 'mod/WatchlistToggle'
import Icon from 'com/Icon'
import { SEC_TYPE } from 'const/stock'

export default {
  name: 'SideStockHead',
  components: {
    WatchlistToggle,
    Icon
  },
  props: {
    stock: Object
  },
  methods: {
    openStock() {
      this.close()
      if (this.stock.secType === SEC_TYPE.OPT) {
        this.$store.dispatch('addOption', this.stock)
      } else {
        this.$store.dispatch('addTradeStock', this.stock)
        this.$router.push(`/quote/${this.stock.symbol}`)
      }
    },
    close() {
      this.$store.dispatch('closeSideStockView')
    }
  }
}
</script>
<style lang="less" scoped>
.external-view-head {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 41px;
  line-height: 40px;
  padding: 0 10px;
  border-bottom: 1px solid var(--special-color);
  font-size: 14px;
  font-weight: bold;
}
.icon {
  margin-left: 8px;
  color: var(--sub-text-color);
  cursor: pointer;
  &:hover {
    color: var(--active-color);
  }
}
</style>
